import { useId } from 'react';

import { Input } from 'components/ui/input';
import { cn } from 'lib/utils';

export function CheckoutTextField({
    children,
    className,
    error,
    fullWidth,
    helperText,
    helperTextRole,
    maxRows,
    minRows,
    multiline,
    select,
    SelectProps,
    ...props
}) {
    const generatedId = useId();
    const helperTextId = helperText
        ? `${props.id || props.name || generatedId}-helper-text`
        : undefined;
    void SelectProps;

    const fieldClassName = cn(
        'border-solid text-foreground placeholder:text-muted-foreground focus:border-primary/50 focus-visible:ring-2 focus-visible:ring-ring',
        error && 'border-destructive focus:border-destructive',
        fullWidth && 'w-full',
        className,
    );

    const describedBy =
        [props['aria-describedby'], helperTextId].filter(Boolean).join(' ') || undefined;

    const fieldProps = {
        ...props,
        'aria-invalid': Boolean(error),
        'aria-describedby': describedBy,
    };

    return (
        <div className={cn(fullWidth && 'w-full')}>
            {select ? (
                <select
                    {...fieldProps}
                    className={cn(
                        'flex h-9 w-full rounded-md border border-solid border-[hsl(var(--border))] bg-[hsl(var(--input))] px-3 py-1 text-base text-foreground shadow-sm transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                        fieldClassName,
                    )}
                >
                    {children}
                </select>
            ) : multiline ? (
                <textarea
                    {...fieldProps}
                    rows={minRows || maxRows}
                    className={cn(
                        'flex min-h-9 w-full rounded-md border border-solid border-[hsl(var(--border))] bg-[hsl(var(--input))] px-3 py-2 text-base text-foreground shadow-sm transition-colors focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                        fieldClassName,
                    )}
                />
            ) : (
                <Input {...fieldProps} className={fieldClassName} />
            )}
            {helperText ? (
                <p
                    id={helperTextId}
                    role={helperTextRole}
                    className={cn(
                        'mt-1 text-sm text-muted-foreground',
                        error && 'text-destructive',
                    )}
                >
                    {helperText}
                </p>
            ) : null}
        </div>
    );
}
